import styled from "@emotion/styled"
import { FusionColor } from "../../../theme/FusionStyle"
import { withProps } from "../../../lib/util"

export enum V2L1ProgressBarSegmentType {
	Pending = 'pending',
	Success = 'success',
	Error = 'error',
}

const segmentTypeColor = (type: V2L1ProgressBarSegmentType) => {
	switch(type) {
		case V2L1ProgressBarSegmentType.Pending:
			return FusionColor.OrangeMain
		case V2L1ProgressBarSegmentType.Success:
			return FusionColor.GoGreen
		 case V2L1ProgressBarSegmentType.Error:
			return FusionColor.StopRed
	}
}

export interface V2L1ProgressBarSegment {
	type: V2L1ProgressBarSegmentType
	amount: number
}

const V2L1ProgressBarRoot = styled.div(({theme}) => ({
	display: 'inline-block',
	minWidth: '10rem',
	height: '0.25rem',
	borderRadius: '2px',
	overflow: 'hidden',
	backgroundColor: theme.colors.lines,
	position: 'relative',
}))

const ProgressBarBar = styled('div', withProps([], ['type']))<V2L1ProgressBarSegment>(({theme, type, amount}) => ({
	width: `${amount * 100}%`,
	height: '100%',
	borderRadius: '2px',
	position: 'absolute',
	top: 0,
	left: 0,
	backgroundColor: theme.colors[segmentTypeColor(type)],
	transition: '0.25s ease-out',
}))

interface V2L1ProgressBarProps {
	segments: V2L1ProgressBarSegment[]
}

export const V2L1ProgressBar = ({segments}: V2L1ProgressBarProps) => {
	let total = 0
	return (
		<V2L1ProgressBarRoot>
			{segments.map((segment, idx) => {
				total += segment.amount
				return <ProgressBarBar key={idx} type={segment.type} amount={total} />
			}).reverse()}
		</V2L1ProgressBarRoot>
	)
}
